export default function normalizePaymentCreate(values) {
  const selectedInvoices = values.data.invoices.filter(
    (invoice) => invoice.isSelected,
  );
  return {
    data: {
      ...values.data,
      invoices: selectedInvoices.map((invoice) => ({
        invoice_id: invoice.invoice_id,
        amount: invoice.amount,
      })),
      amount: selectedInvoices.reduce(
        (acc, invoice) => acc + parseFloat(invoice.amount),
        0,
      ),
    },
  };
}
